'use strict';

import $ from 'jquery';
import storage from './storage';
import tyreselector from './tyreselector-4';
import filterBar from './filter-bar';
import 'select2';

let tyreselectorLicense = {

  form: $('form[name="licenseSearchForm"]'),
  missingLicenseData: false,
  get submitBtn (){ return $(this.form).find('[type="submit"]'); },
  get resultsContainer (){ return $(this.form).find('.licenseResults'); },
  get clonedResultsContainer () { return $('.filter-bar .sizes.license:first'); },
  get resultsEl (){ return $(this.resultsContainer).find('.results'); },
  get clearBtn (){ return $(this.form).find('.clearBtn'); },
  get errorEl (){ return $(this.form).find('.errorMessage:first'); },
  storage: ( storage.session ? sessionStorage : null),

  resetSubmit: function(){
    var self = this;
    if( !$(self.form).find('[name="license"]').length ) return false;
    var value = $(self.form).find('[name="license"]').val();
    if( !value || value.length <= 2 ) $(self.submitBtn).prop('disabled',true);
    else $(self.submitBtn).prop('disabled',false);

    if( $(self.form).find('[name="license"]').val() ) self.resetClear(true);
    else self.resetClear(false);

  }, // resetSubmit()

  resetClear: function(visible){
    var self = this;
    var btn = $(self.form).find('.clearBtn:first');
    if( visible && $(btn).not(':visible') ) $(btn).slideDown('fast');
    else if( !visible && $(btn).is(':visible') ) $(btn).slideUp('fast');
  },

  resetForm: function(){
    var self = this;
    var $form = $(self.form);

    // Return if no license plate form
    if(!$form.length) {
      return;
    }

    $form[0].reset();
    self.resetSubmit();
    self.resetClear(false);
    self.missingLicenseData = false;
    $(self.errorEl).hide();

    // if we're on tyres page then set default action and text as well
    if( $(tyreselector.tsEl).hasClass('tyres') ){
      tyreselector.modifyTsSubmitButton($(self.submitBtn),false);
    }
    if( window.cookieObj && window.cookieObj.license ){
      delete window.cookieObj.license;
      if( window.cookieObj.id ) delete window.cookieObj.id;
      if( window.cookieObj.productInfo ) delete window.cookieObj.productInfo;
      if( window.cookieObj.productName ) delete window.cookieObj.productName;

      window.setTyreCookie();
      if( typeof tyreselector.parseResults !== 'undefined' ) tyreselector.parseResults(); // this updates header as well
    }
    $(self.resultsContainer).slideUp('fast',function(){
      self.resultsEl.html('').show();
    });
  },

  resetLicenseForm: function(){
    var self = this;
    self.resetForm();
    return true;
  },

  getLicenseResults: function(license,country){
    var self = this;
    if( typeof license === 'undefined' || !license || typeof country === 'undefined' || !country ) return false;
    var storageKey = 'license_' + ( window.cookieObj && window.cookieObj.license && window.cookieObj.license.country ? window.cookieObj.license.country + '_' : '' ) + license.replace(/\W/g, '_');
    var licenseResult = null;

    // check if we have pre-fetched license results for current license
    if( self.storage ){
      licenseResult = sessionStorage.getItem(storageKey);
      if( licenseResult ){
        try{
          licenseResult = JSON.parse(licenseResult);
          if( typeof licenseResult.data !== 'undefined' ){
            window.cookieObj.license.data = licenseResult.data;

            window.setTyreCookie();
          }
        }
        catch(e){ licenseResult = null; }
      }
    }

    if( !licenseResult ){
      $(self.resultsContainer).toggleClass('loading',true);
      if( $(self.resultsContainer).not(':visible') ) $(self.resultsContainer).slideDown('fast');

      $.ajax({
        url: '/stage-ajax/searchLicense',
        data: {
          license: license,
          country: country
        },
        error: function(jqXHR, textStatus, errorThrown) {
          $(self.resultsContainer).toggleClass('loading',false);
          var errorMsg;
          errorMsg = errorThrown ? 'Error: ' + errorThrown + '. ' : 'Error. ';
          errorMsg += window.loc && window.loc.tyreselector_try_again_later ? window.loc.tyreselector_try_again_later : ' Please try again later. Sorry for the inconvenience.';
          self.populateResults( errorMsg );
          console.error(textStatus, errorThrown);
        },
        success: function(data){
          // do not store error strings, only object data
          if( self.storage && data && typeof data.data === 'object' ){
            self.storage.setItem(storageKey,JSON.stringify(data));
          }
          if( window.cookieObj && window.cookieObj.license && data && typeof data.data === 'object' ){
            window.cookieObj.license.data = data.data;

            window.setTyreCookie();
          }
          self.populateResults( data );
        }
      });
    }
    else self.populateResults( licenseResult );
  }, // getLicenseResults

  splitTyreInfoToValues: function(str){
    // this function takes a tyre info string and tries to extract width/height/rim infos into an object
    // examples of different tyre markings: http://www.tirerack.com/tires/tiretech/techpage.jsp?techid=46
    if( typeof str === 'undefined' || !str ) return null;
    if( (str.match(/\//g) || []).length !== 1 ) return null; // only one '/' character

    var hr = str.indexOf('/')!==-1 ? str.split('/')[1] : null,
      hrLetters = hr ? hr.replace(/[0-9]/g,'') : null, // get all letters from hr string
      splitter = hrLetters ? hrLetters.substring(0,1) : 'R', // choose first letter to be the string splitting point
      w,
      h,
      r;

    w = parseInt(str.split('/')[0].replace(/\D/g,'')); // remove all but numbers and convert to number
    h = parseInt(str.split('/')[1].split(splitter)[0]); // characters after '/' up to splitter character define height (tyre's aspect ratio)
    r = parseInt(str.split(splitter)[1].replace(/\D/g,'')); // remove all but numbers and convert to number

    if( isNaN(w) || isNaN(h) || isNaN(r) ) return null;

    return {'str': str,'width': w,'height': h,'rim': r};
  }, // splitTyreInfoToValues()

  populateResults: function(data){

    // populate results from license search
    var self = this;
    self.missingLicenseData = false;

    var i,
      ii;

    function activateSize(input){
      $(input).attr('checked','checked').parents('.result').toggleClass('active',true);
      // store selection to cookie, if it has none
      if( window.cookieObj && window.cookieObj.tsViewNavItem === '#filterLicense'/*  (!window.cookieObj.width || !window.cookieObj.height || !window.cookieObj.rim ) */ ){
        var value = input.val(),
          splitted = value ? value.split(',') : false;

        if( value ) {
          /* remove other searches results by customer request */
          if( window.cookieObj.manufacturer ) delete window.cookieObj.manufacturer;
          if( window.cookieObj.year ) delete window.cookieObj.year;
          if( window.cookieObj.model ) delete window.cookieObj.model;
          if( window.cookieObj.vehicle ) delete window.cookieObj.vehicle;
          if( window.cookieObj.id ) delete window.cookieObj.id;
          if( window.cookieObj.productInfo ) delete window.cookieObj.productInfo;
          if( window.cookieObj.productName ) delete window.cookieObj.productName;

          window.cookieObj.width = ~~splitted[0];
          window.cookieObj.height = ~~splitted[1];
          window.cookieObj.rim = ~~splitted[2];

          window.setTyreCookie();
          if( typeof tyreselector.parseResults !== 'undefined' ) tyreselector.parseResults(); // this updates header as well

          input.parents('form').find('[type="submit"]').each(function(){
            tyreselector.modifyTsSubmitButton($(this),true);
          });

        }
      }
    } // activateSize()

    // first check what kind of result should be shown.
    // hide results if no data
    if( !data ){
      if( $(self.resultsContainer).is(':visible') ){
        $(self.resultsContainer).hide();
        $(self.resultsContainer).toggleClass('loading',false);
        $(self.resultsEl).contents().remove();
      }
      // update results and mobile dropdown in .filter-bar
      filterBar.updateFilterBar('licenseSearchForm');

    }
    // driveright data is missing, show string containing message
    else if( typeof( data ) === 'string' ){
      if( $(self.resultsContainer).not(':visible') ) $(self.resultsContainer).slideDown('fast');
      $(self.resultsContainer).toggleClass('loading',false);
      $(self.resultsEl).contents().remove();
      $(self.resultsEl).append('<span class="error">'+data+'</span>');

      $(self.errorEl).contents().remove();
      $(self.errorEl).append(data).show();
      self.missingLicenseData = true;

      // update results and mobile dropdown in .filter-bar
      filterBar.updateFilterBar('licenseSearchForm');

      if( $(self.resultsEl).not(':visible') ){
        $(self.resultsEl).show();
      }
    }
    else {

      if( $(self.resultsContainer).not(':visible') ) $(self.resultsContainer).slideDown('fast');
      $(self.resultsContainer).toggleClass('loading',false);

      // choosing by license should delete other search values and reset forms
      if( typeof tyreselector.resetTyreSelectorForms === 'function' ) tyreselector.resetTyreSelectorForms(['modelSearchForm','sizeSearchForm']);

      $(self.resultsEl).contents().remove();

      var resultArray = [],
        atLeastOneIsAvailable = false,
        defaultIsAvailable = false;

      // loop result tyres and push them to resultArray as compatible objects
      if( data && data.data && data.data.tyres ){
        // check if we have sorted keys. if so, use them to build resultArray
        if( data.data.sorted ){
          $(data.data.sorted).each(function(i,key){
            // split prop into an object with parsed values
            var splittedKey = self.splitTyreInfoToValues(key);
            if( splittedKey ){
              resultArray.push({value: key,text: [splittedKey.width,splittedKey.height,splittedKey.rim],'default': data.data.tyres[key]});
            } // splittedKey
          });
        }
        // no sorted keys available, use tyres as-is
        else {
          var sourceObj = data.data.tyres;
          for( var prop in sourceObj ){
            if( Object.prototype.hasOwnProperty.call(sourceObj, prop) ){
              // split prop into an object with parsed values
              var splittedProp = self.splitTyreInfoToValues(prop);
              if( splittedProp ){
                resultArray.push({value: prop,text: [splittedProp.width,splittedProp.height,splittedProp.rim],'default': sourceObj[prop]});
              } // splittedProp
            }
          }
        }
      }

      // loop thru results and create html elements
      for( i=0;i<resultArray.length;i++ ){
        var newResult = $(window.newResult()),
          width = parseInt(resultArray[i].text[0]),
          height = parseInt(resultArray[i].text[1]),
          rim = parseInt(resultArray[i].text[2]),
          value = width+','+height+','+rim, //+','+minLI+','+minSP,
          inputEl = newResult.find('input'),
          widthEl = newResult.find('.width'),
          heightEl = newResult.find('.height'),
          rimEl = newResult.find('.rim'),
          availableEl = newResult.find('.availabilityTxt'),
          defaultEl = newResult.find('.defaultTxt'),
          defaultSizeCheck = function(){
            return resultArray[i]['default'];
          },
          defaultSize = defaultSizeCheck(),
          available = false,
          keys = ['width','height','rim','li','sp'];

        // Check availability by comparing to sizeData
        for( ii=0;ii<window.sizeData.length;ii++ ){
          if( window.sizeData[ii][keys.indexOf('width')] === width && window.sizeData[ii][keys.indexOf('height')] === height && window.sizeData[ii][keys.indexOf('rim')] === rim ){
            // size matches, do additional filtering:
            available = true;
            atLeastOneIsAvailable = true;
            if( defaultSize ) defaultIsAvailable = true;
            break;
          } // sizeMatch
        } // end availability loop

        // set values
        $(inputEl).val(value);
        $(widthEl).text(width);
        $(heightEl).text(height);
        $(rimEl).text(rim);

        if( !defaultSize ) defaultEl.remove();
        else $(inputEl).attr('data-manufacturer-default','true');

        if( !available ){
          $(defaultEl).remove(); // no need to show defaultEl if the tyre is not available.
          $(newResult).toggleClass('notAvailable',true);
          $(inputEl).prop('disabled',true);
        }
        else {
          // it is available, so must remove text 'not available'
          $(availableEl).remove();
        }

        $(newResult).on('click', function(e){
          if( !$(this).hasClass('notAvailable') ){
            $('.result').toggleClass('active',false);
            $(this).toggleClass('active',true);
          }
        });

        $(self.resultsEl).append(newResult);

      } // end loop

      // set active size
      if( atLeastOneIsAvailable || defaultIsAvailable ){
        // get active radio inputs
        var inputs = $(self.form).find('input[type="radio"]').not(':disabled');

        // if cookie contains info about selected size, and that size happens to be available, select that size.
        var selectedSizeStr = (window.cookieObj.width && window.cookieObj.height && window.cookieObj.rim) ? window.cookieObj.width+','+window.cookieObj.height+','+window.cookieObj.rim : false,
          matchedInput = false;

        if( selectedSizeStr ){
          $(inputs).each(function(){
            if( $(this).val() === selectedSizeStr ) matchedInput = $(this);
          });
        }
        if( selectedSizeStr && matchedInput ) {
          activateSize(matchedInput);
        }
        // else if manufacturers default size is available, choose it.
        else if( defaultIsAvailable ){
          activateSize($(inputs).filter('[data-manufacturer-default="true"]:first'));
        }
        // at least, choose the first option
        else {
          activateSize($(inputs).eq(0));
        }
      }

      $(self.resultsContainer).toggleClass('loading',false);
      $(self.resultsContainer).show();

      if( atLeastOneIsAvailable ){
        $(self.resultsEl).find('input:checked').focus();
      }

      // update results and mobile dropdown in .filter-bar
      filterBar.updateFilterBar('licenseSearchForm');

      if( window.cookieObj && window.cookieObj.tsViewNavItem === '#filterLicense' && typeof tyreselector.parseResults !== 'undefined' ) tyreselector.parseResults();

    } // we have data


  }, // populateResults

  init: function(){
    console.log('TS4: tyreselectorLicense.init()');

    var self = this;

    tyreselector.licenseForm = self;

    // if license data available, populate form
    if( window.cookieObj && window.cookieObj.license && window.cookieObj.license.text && window.cookieObj.license.country ){
      var countryMatch = window.tsSettings.countryCodeForStageLanguage === window.cookieObj.license.country;
      if( countryMatch ) {
        $(self.form).find('[name="license"]').val(window.cookieObj.license.text);
        if( tyreselector.tsEl.hasClass('tyres') ) self.getLicenseResults(window.cookieObj.license.text,window.cookieObj.license.country);
      }
    } // license data available

    self.clearBtn.on('click', function(e){
      e.preventDefault();
      tyreselector.resetTyreSelectorForms();
    });

    $(self.form).find('[name="license"]').on('keyup blur',function(e){
      // enable/disable submit.
      self.resetSubmit();

      // on 'tyres' page we may have to do special things if conditions are right. Let's check them.
      if( tyreselector.tsEl.hasClass('tyres') ){
        var value = $(this).val();

        // if license is known and current value does not match, reset submit button's default text and action.
        if( window.cookieObj.license && window.cookieObj.license.text !== value ){
          tyreselector.modifyTsSubmitButton( $(self.submitBtn),false );
        }
        // enable secondary submit action and text if license and value match
        else if( window.cookieObj.license && window.cookieObj.license.text === value ){
          tyreselector.modifyTsSubmitButton( $(self.submitBtn),true );
        }

        // autosubmit:
        // if field value length is maximum and user is on "tyres" page and it's a new license value: do autosubmit! This is by customer's request.
        if( value.length === Number($(this).attr('maxlength')) && (!window.cookieObj || !window.cookieObj.license || window.cookieObj.license.text !== value ) ){
          // reset button's text and action
          var diipa = tyreselector.modifyTsSubmitButton($(self.submitBtn),false);
          if( diipa ) void(diipa);
        }
      } // tyres page


    });

    // radio button changes
    $(document).on('change','form[name="licenseSearchForm"] input[type="radio"][name="tyreSize"]',function(e){

      var value = $(this).val();
      // store changed value right away for product filtering
      if( value ) {
        var splitted = value.split(',');
        if( splitted.length > 2 && window.cookieObj.tsViewNavItem==='#filterLicense'){
          window.cookieObj.width = ~~splitted[0];
          window.cookieObj.height = ~~splitted[1];
          window.cookieObj.rim = ~~splitted[2];

          window.setTyreCookie();
        }
      }

      if( typeof tyreselector.parseResults !== 'undefined' ) tyreselector.parseResults(); // this updates header as well

    });

    // update header & results if we already have license
    if( typeof tyreselector.parseResults !== 'undefined' ) {
      tyreselector.parseResults(); // this updates header as well
    }

    self.resetSubmit();

  } // init()

};

export default tyreselectorLicense;
